<template>
  <div class="country-filter">
    <filter-province
      :country-info="countryInfo"
      :province_code.sync="inner_province_code"
    ></filter-province>
    <filter-visa-type
      :country-info="countryInfo"
      :visa_type.sync="inner_visa_type"
    ></filter-visa-type>
    <div class="country-info">
      <img class="country-flag" :src="countryInfo.national_flag_img" alt="" />
      <div class="country-name">{{ countryInfo.country }}</div>
    </div>
  </div>
</template>

<script>
import FilterProvince from './components/filter-province.vue';
import FilterVisaType from './components/filter-visa-type.vue';

export default {
  components: {
    FilterProvince,
    FilterVisaType,
  },
  props: {
    province_code: Number,
    visa_type: String,
    countryInfo: Object,
  },
  data() {
    return {};
  },
  computed: {
    inner_province_code: {
      get() {
        return this.province_code;
      },
      set(value) {
        this.$emit('update:province_code', value);
      },
    },
    inner_visa_type: {
      get() {
        return this.visa_type;
      },
      set(value) {
        this.$emit('update:visa_type', value);
      },
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.country-filter {
  width: 100%;
  background: #fff;
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ededed;
  .country-info {
    flex-shrink: 0;
    max-width: 112px;
    height: 100%;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border-left: 1px solid #e9eef2;
    .country-flag {
      height: 16px;
      flex-shrink: 0;
      margin-right: 8px;
    }
    .country-name {
      flex-grow: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #222222;
      font-size: 14px;
    }
  }
}
</style>
